import { render } from "./Consent.vue?vue&type=template&id=31232df6&scoped=true"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"

import "./Consent.vue?vue&type=style&index=0&id=31232df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31232df6"]])

export default __exports__